export default __webpack_public_path__ + "static/media/Rafeya.86b86a7d.jpg";